import script from "./GoogleMaps.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleMaps.vue?vue&type=script&setup=true&lang=js"

import "./GoogleMaps.vue?vue&type=style&index=0&id=8b4a8fd0&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4a8fd0"]])

export default __exports__